<template>
  <div>
    <div style="visibility: hidden;">
      <iframe :src="printFileUrl" height="0px" width="0px"/>
    </div>
    <el-dialog :visible.sync="previewVisiable" :title="$t('print.preview')" height="700" width="1100px"
      append-to-body v-el-drag-dialog>
      <el-main v-loading="previewLoading" style="padding-top:0px;padding-bottom:15px">
        <iframe ref="pdfViewer" :src="fileUrl" height="600vh" width="100%"/>
         <!--   -->
      </el-main>
    </el-dialog>
  </div>
</template>
<script>
import printJS from 'print-js'
export default {
  name: 'PrintPreview',
  data() {
    return {
      previewVisiable: false,
      previewLoading: false,
      printFileUrl: '',
      fileUrl:'',
      browserType:'Chrome'
    }
  },
  methods: {
    handlePreviewFile(fileUrl) {
      this.browserType=this.getBrowserType()
      this.previewVisiable = true
      if(this.browserType==='Edge'){
        // console.log(fileUrl)
        // this.$refs.pdfViewer.contentWindow.navigator.msSaveOrOpenBlob(fileUrl)
        this.fileUrl = './static/pdf/web/viewer.html?file=' + fileUrl
      }else{
        this.fileUrl = fileUrl
      }
    },
    handlePrintFile(fileUrl){
      this.browserType=this.getBrowserType()
      switch(this.browserType){
        case 'Chrome':
          printJS(fileUrl)
          break
        default:
          this.printFileUrl = './static/pdf/web/viewer.html?file=' + fileUrl + '&print=true'
          break
      }
      
    },
    getBrowserType(){
      var userAgent = navigator.userAgent
      if (userAgent.indexOf("Opera") > -1) {
        return "Opera"
      }else if (userAgent.indexOf("Edge") > -1){
        return "Edge";
      }else if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
      }else if  (userAgent.indexOf("Chrome") > -1){
        return "Chrome";
      }else if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
      }else if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1) {
        return "IE";
      }
    }
  }
}
</script>

